import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';
import { baseTheme } from '../base-theme';

export const MuiInputLabel: {
    defaultProps?: ComponentsProps['MuiInputLabel'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiInputLabel'];
    variants?: ComponentsVariants['MuiInputLabel'];
} = {
    defaultProps: {
        shrink: true,
    },
    styleOverrides: {
        root: () => ({
            position: 'unset',
            transform: 'unset',
            transition: 'unset',
            paddingBlockEnd: baseTheme.spacing(baseTheme.tokens.spacing.xxs),
        }),
    },
};
